import { AxiosResponse } from "axios";
import { BASE_URL, NAV_URL, httpClient } from "../config/develop-config";
import { OrderPaymentStatusKey, OrderStatusKey } from "../definitions/orderStatus";
import { OrderSubStatus } from "../definitions/invoice";

export const urlCreditAuth = `${BASE_URL}/auth/temporary-credit-limit`;
export const urlCart = `${BASE_URL}/order-cart`;
export const urlNav = `${NAV_URL}`;
export const authUrl = `${BASE_URL}/auth`;

const getDetail = async (cusComId: string) => {
  return await httpClient
    .get(`${urlCreditAuth}/credit-limit-shop-detail/${cusComId}`, {
      params: { cusComId },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const countTabs = async (cusComId: string) => {
  return await httpClient
    .get(`${urlCreditAuth}/count-tab-detail-shop/${cusComId}`, {
      params: { cusComId },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getOverCredit = async (params: {
  customerCompanyId: number;
  status: string;
  search: string;
  page: number;
  take: number;
}) => {
  return await httpClient
    .get(`${urlCreditAuth}/temporary-credit-limit-shop/`, {
      params,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getInvoiceByCusCom = async (params: {
  customerCompanyId: string;
  paymentStatus?: OrderSubStatus;
  paymentStatuses?: OrderSubStatus[];
  search?: string;
  startDate?: string;
  endDate?: string;
  page: number;
  pageSize: number;
}) => {
  return await httpClient
    .get(`${urlCart}/invoice/get-by-cus-com`, {
      params,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getInvoiceCountByCusCom = async (cusComId: string) => {
  return await httpClient
    .get(`${urlCart}/invoice/get-count-by-cus-com/${cusComId}`, {
      params: { cusComId },
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getOrderCreditPayment = async (params: any) => {
  return await httpClient
    .get(`${authUrl}/order-credit-payment/order-credit-payment`, { params })
    .then((res: AxiosResponse) => res)
    .catch((err) => console.log(err));
};

const syncCreditLimit = async (data: { company: string; customerNo: string }) => {
  return await httpClient
    .post(`${urlNav}/customer/sync-credit-limit-customer`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const syncInvoice = async (data: { company: string; customerNo: string }) => {
  return await httpClient
    .post(`${urlNav}/invoice`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const syncInvoicePayment = async (data: { company: string; customerNo: string }) => {
  return await httpClient
    .post(`${urlNav}/order-pending-credit/invoice-payment`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const syncInvoiceCancelPayment = async (params: { company: string; invoiceNo: string }) => {
  return await httpClient
    .post(`${urlNav}/order-credit-payment/cancel-payment`, params, {
      responseType: "arraybuffer",
    })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getInvoiceTemporary = async (params: any) => {
  return await httpClient
    .get(`${authUrl}/order-credit-payment/temporary-credit-used/${params.customerCompanyId}`, {
      params,
    })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getArBalanceDetail = async (cusComId: string) => {
  return await httpClient
    .get(`${authUrl}/order-credit-payment/ar-balance-by-credit/${cusComId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export {
  getDetail,
  countTabs,
  getOverCredit,
  getInvoiceByCusCom,
  getInvoiceCountByCusCom,
  getOrderCreditPayment,
  getInvoiceTemporary,
  syncCreditLimit,
  syncInvoice,
  syncInvoicePayment,
  syncInvoiceCancelPayment,
  getArBalanceDetail,
};
